import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommercialLayout from '../../components/commercial/CommercialLayout';
import { useAuth } from '../../contexts/AuthContext';
import pb from '../../lib/pocketbase';
import confetti from 'canvas-confetti';

export default function CommercialFormationPage() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    // Checklist State
    const [steps, setSteps] = useState([
        { id: 1, label: "J'ai visionné la vidéo de présentation", checked: false },
        { id: 2, label: "J'ai pris connaissance de la charte éthique", checked: false },
        { id: 3, label: "J'ai configuré ma signature email pro", checked: false },
        { id: 4, label: "Je suis prêt à démarrer mon activité", checked: false },
    ]);

    const allChecked = steps.every(s => s.checked);

    const toggleStep = (id) => {
        setSteps(prev => prev.map(s => s.id === id ? { ...s, checked: !s.checked } : s));
    };

    const handleCompleteFormation = async () => {
        if (!allChecked) return;
        setLoading(true);
        try {
            const record = await pb.collection('commercial_profiles').getFirstListItem(`user="${user.id}"`);
            await pb.collection('commercial_profiles').update(record.id, {
                level: 2
            });

            confetti({
                particleCount: 200,
                spread: 100,
                origin: { y: 0.6 },
                colors: ['#22c55e', '#ffffff']
            });

            // Small delay for effect
            setTimeout(() => {
                navigate('/commercial/admin');
            }, 1500);

        } catch (err) {
            console.error("Error completing formation:", err);
            alert("Erreur lors de la validation. Assurez-vous d'avoir un profil actif.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <CommercialLayout title="Formation Initiale">
            <div style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 20px', fontFamily: 'Inter, sans-serif' }}>

                {/* ORIGINAL HEADER RESTORED */}
                <div style={{ textAlign: 'center', marginBottom: 40 }}>
                    <div style={{ fontSize: '4rem', marginBottom: 20 }}>🎓</div>
                    <h1 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: 10, color: 'var(--commercial-text)' }}>Formation & Onboarding</h1>
                    <p style={{ maxWidth: 600, margin: '0 auto', opacity: 0.7, lineHeight: 1.6, color: 'var(--commercial-muted)' }}>
                        Bienvenue dans votre espace de formation. Ici, vous apprendrez à maîtriser tous les outils mis à votre disposition.
                        <br />
                        (Module à venir "juste après") 🚧
                    </p>
                </div>

                {/* HERO VIDEO */}
                <div style={{
                    aspectRatio: '16/9',
                    background: 'black',
                    borderRadius: 24,
                    overflow: 'hidden',
                    marginBottom: 40,
                    boxShadow: '0 20px 50px -10px rgba(0,0,0,0.5)',
                    position: 'relative',
                    border: '1px solid var(--commercial-border)'
                }}>
                    {/* Placeholder for video */}
                    <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', color: 'white', background: 'linear-gradient(45deg, #111, #222)' }}>
                        <div style={{ fontSize: '5rem', marginBottom: 20, opacity: 0.8 }}>▶️</div>
                        <div style={{ fontSize: '1.8rem', fontWeight: 700 }}>Vidéo de Bienvenue (Onboarding)</div>
                        <div style={{ marginTop: 10, opacity: 0.5 }}>Cliquez pour visionner (Simulation)</div>
                    </div>
                </div>

                {/* CONTENT GRID */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 40, alignItems: 'start' }}>

                    {/* LEFT: INFO */}
                    <div>
                        <h2 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: 20, lineHeight: 1.1, color: 'var(--commercial-text)' }}>
                            Prêt à rejoindre <br />
                            <span style={{ color: 'var(--commercial-accent)' }}>l'Élite Commerciale</span> ?
                        </h2>

                        <div style={{ background: 'var(--commercial-panel)', padding: 25, borderRadius: 16, border: '1px solid var(--commercial-border)' }}>
                            <h3 style={{ margin: '0 0 10px 0', fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: 8, color: 'var(--commercial-text)' }}>
                                🚀 Objectif : Niveau 2
                            </h3>
                            <p style={{ margin: 0, fontSize: '0.95rem', color: 'var(--commercial-muted)' }}>
                                Valider cette étape débloquera l'accès complet à votre <strong>Tableau de Bord</strong>, vos <strong>outils de prospection</strong> et votre <strong>CRM</strong>.
                            </p>
                        </div>
                    </div>

                    {/* RIGHT: CHECKLIST */}
                    <div style={{ background: 'var(--commercial-panel)', padding: 30, borderRadius: 24, border: '1px solid var(--commercial-border)', boxShadow: '0 10px 30px -5px rgba(0,0,0,0.1)' }}>
                        <h3 style={{ marginTop: 0, marginBottom: 25, display: 'flex', alignItems: 'center', gap: 10, color: 'var(--commercial-text)', justifyContent: 'center' }}>
                            <span>📋</span> Checklist de Validation
                        </h3>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            {steps.map(step => (
                                <div
                                    key={step.id}
                                    onClick={() => toggleStep(step.id)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 15,
                                        padding: 16,
                                        background: step.checked ? 'rgba(34, 197, 94, 0.1)' : 'var(--commercial-panel-2)',
                                        border: `1px solid ${step.checked ? '#22c55e' : 'var(--commercial-border)'}`,
                                        borderRadius: 12,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        transform: step.checked ? 'scale(1.02)' : 'scale(1)'
                                    }}
                                >
                                    <div style={{
                                        width: 24, height: 24, borderRadius: 6,
                                        border: `2px solid ${step.checked ? '#22c55e' : 'var(--commercial-muted)'}`,
                                        background: step.checked ? '#22c55e' : 'transparent',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: 'white', fontWeight: 'bold', fontSize: 14,
                                        flexShrink: 0
                                    }}>
                                        {step.checked && '✓'}
                                    </div>
                                    <span style={{
                                        fontWeight: 500,
                                        textDecoration: step.checked ? 'line-through' : 'none',
                                        opacity: step.checked ? 0.7 : 1,
                                        color: 'var(--commercial-text)'
                                    }}>
                                        {step.label}
                                    </span>
                                </div>
                            ))}
                        </div>

                        <div style={{ marginTop: 30, textAlign: 'center' }}>
                            <button
                                onClick={handleCompleteFormation}
                                disabled={!allChecked || loading}
                                style={{
                                    padding: '20px 40px',
                                    width: '100%',
                                    background: allChecked ? '#22c55e' : 'var(--commercial-panel-2)',
                                    color: allChecked ? 'white' : 'var(--commercial-muted)',
                                    border: allChecked ? 'none' : '1px solid var(--commercial-border)',
                                    borderRadius: 12,
                                    fontSize: '1.2rem',
                                    fontWeight: 800,
                                    cursor: allChecked ? 'pointer' : 'not-allowed',
                                    transition: 'all 0.3s',
                                    opacity: allChecked ? 1 : 0.7,
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    boxShadow: allChecked ? '0 10px 25px -5px rgba(34, 197, 94, 0.4)' : 'none'
                                }}
                            >
                                {loading ? 'Validation en cours...' : (allChecked ? 'Valider la Formation & Accéder au Dashboard' : 'Complétez les 4 étapes pour Valider')}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </CommercialLayout>
    );
}
